// extracted by mini-css-extract-plugin
module.exports = {"reportButton":"style__reportButton__RFHjT"};